import React from 'react';
import styled from 'styled-components';
import { useAdminSupport } from '../../share/hook/useAdminSupport';
import AdminBlockWithVisible from '../../share/component/AdminBlockWithVisible';

const SupportColumnInfo: React.FC = () => {
  const { activeSupport } = useAdminSupport();

  return (
    <ColumnInfoComp>
      <InfoContainer>
        <TitleBlock>Title</TitleBlock>
        <AdminBlockWithVisible
          width={"1.5"}
          isColumn={true}
          value={"Type"}
        />
        <AdminBlockWithVisible
          width={"1.5"}
          isColumn={true}
          value={"AUI"}
        />
        <AdminBlockWithVisible
          width={"1.5"}
          isColumn={true}
          value={"Date"}
        />
        <AdminBlockWithVisible
          width={"1.5"}
          isColumn={true}
          value={"Status"}
        />
        {activeSupport && <SpaceBlock />}
      </InfoContainer>
      {activeSupport &&
        <OverviewBlock>Overview</OverviewBlock>
      }
    </ColumnInfoComp>
  );
};


const ColumnInfoComp = styled.article`
  width: 100%;
  height: 38px;
  display: flex;
  border-bottom: 1px solid ${({ theme }) => theme.colors.color_Gray_02};

  ${({ theme }) => theme.typography.Body_03_2};
`;
const InfoContainer = styled.article`
  flex: 1;
  width: auto;
  height: 34px;
  display: flex;
`;
const TitleBlock = styled.div`
  flex: 2.5;
  display: flex;
  align-items: center;
  padding-left: 10px;
`

const SpaceBlock = styled.div`
  flex: 0.15;
  display: flex;
  align-items: center;
  justify-content: center;
`

const OverviewBlock = styled.div`
  width: 29vw;
  display: flex;
  align-items: center;
`

export default SupportColumnInfo;